import { render, staticRenderFns } from "./UserOrderList.vue?vue&type=template&id=fc43d458&scoped=true&"
import script from "./UserOrderList.vue?vue&type=script&lang=ts&"
export * from "./UserOrderList.vue?vue&type=script&lang=ts&"
import style0 from "./UserOrderList.vue?vue&type=style&index=0&id=fc43d458&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc43d458",
  null
  
)

export default component.exports